import React from 'react';
import { useParams, Link } from 'react-router-dom';

const Invite: React.FC = () => {
  const { path } = useParams();

  return (
    <div className="Page-content">
      <Link to="/" className="Page-back">← back</Link>
      <div className="Invite-content">
        <p>Bye For Now invite</p>
        <a href={`monogatari://invite/${path}`} className="Invite-link">Click to open in app if not automatic</a>
      </div>
    </div>
  );
};
  
export default Invite;